import React, { useState } from 'react';
import { useLingui } from '@lingui/react/macro';

import { Box, Button } from '@rover/kibble/core';
import type { FrontendConfigurationSettingsDogSizeBuckets } from '@rover/rsdk/src/apiClient/latest/model/frontendConfigurationSettingsDogSizeBuckets';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';
import type { SearchFiltersOptions } from '@rover/types/src/apiResponses/SearchOptionsResponse';
import type { SearchFilters } from '@rover/types/src/SearchFilters';

import PetPreferences from '../StickyFiltersBar/PrimaryFiltersBottomSheet/PetPreferences';

import { ColorfulPerfectMatchFieldInteraction } from './analyticsEvents';

type Props = {
  searchFilters: SearchFilters;
  onChange: (filters: Partial<SearchFilters>) => void;
  serviceTypeFilterOptions: SearchFiltersOptions;
  petSizeBuckets: FrontendConfigurationSettingsDogSizeBuckets;
  weightUnit: string;
  isCatOnly: boolean;
};

const AddMoreDetailsSection = ({
  searchFilters,
  onChange,
  serviceTypeFilterOptions,
  petSizeBuckets,
  weightUnit,
  isCatOnly,
}: Props): JSX.Element => {
  const { t } = useLingui();
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = (): void => {
    if (!isExpanded) {
      emitAnalyticsEvent(new ColorfulPerfectMatchFieldInteraction({ field: 'add_more_details' }));
    }
    setIsExpanded(!isExpanded);
  };

  return (
    <Box>
      <Button variant="link" onPress={toggleExpanded}>
        {isExpanded ? t`Hide details` : t`Add more details`}
      </Button>
      {isExpanded && (
        <Box mt="4x">
          <PetPreferences
            searchFilters={searchFilters}
            onChange={onChange}
            serviceTypeFilterOptions={serviceTypeFilterOptions}
            petSizeBuckets={petSizeBuckets}
            weightUnit={weightUnit}
            getServiceTypeBySlug={() => null}
            hasPets={false}
            isCatOnly={isCatOnly}
          />
        </Box>
      )}
    </Box>
  );
};

export default AddMoreDetailsSection;
